import React from 'react';
import { Col, ProgressBar } from 'react-bootstrap';
import Flag from './Flag';
import { priceSplitter } from '../../../utils/helpers/priceSplitter';
import { Audiences } from '../../../model/shared/Audiences';

interface ICountryProgressBarProps {
    country: Audiences;
}
const CountryProgressBar = ({ country }: ICountryProgressBarProps) => {
    return (
        <>
            <Col xs="auto">
                <Flag code={country?.metric} width={35} className="cursor-pointer shadow rounded" />
            </Col>
            <Col xs={9} className="d-flex align-items-center px-2">
                <ProgressBar variant="primary" className="progress-sm w-100 bg-primary-lighter" now={country?.value} />
            </Col>
            <Col xs={2}>
                <p className="text-black-50 d-flex mb-0">{priceSplitter(+country?.value.toFixed(2))}%</p>
            </Col>
        </>
    );
};

export default React.memo(CountryProgressBar);
